"use strict";

angular.module('mainApp').factory('Shop', ['$resource', function ($resource) {
  var Shop;
  Shop = $resource('/api/shop', {
    id: '@id'
  }, {
    redeem: {
      method: 'POST',
      url: '/api/shop/voucher/redeem'
    },
    pay: {
      method: 'PUT',
      url: '/api/shop/pay'
    },
    quote: {
      method: 'POST',
      url: '/api/shop/quote'
    }
  });
  return Shop;
}]);
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlc291cmNlcy9TaG9wLmNvZmZlZSJdLCJuYW1lcyI6WyJhbmd1bGFyIiwibW9kdWxlIiwiZmFjdG9yeSIsIiRyZXNvdXJjZSIsIlNob3AiLCJpZCIsInJlZGVlbSIsIm1ldGhvZCIsInVybCIsInBheSIsInF1b3RlIl0sIm1hcHBpbmdzIjoiOztBQUFBQSxPQUFPLENBQUNDLE1BQVIsQ0FBZ0IsU0FBaEIsQ0FBMEIsQ0FBQ0MsT0FBM0IsQ0FBbUMsTUFBbkMsRUFBMkMsQ0FBRSxXQUFGLEVBQWUsVUFBRUMsU0FBRixFQUFBO0VBRTFELElBQUFDLElBQUE7RUFBRUEsSUFBQSxHQUFPRCxTQUFBLENBQVcsV0FBWCxFQUF3QjtJQUFDRSxFQUFBLEVBQUk7RUFBTCxDQUF4QixFQUNMO0lBQUFDLE1BQUEsRUFDRTtNQUFBQyxNQUFBLEVBQVEsTUFBUjtNQUNBQyxHQUFBLEVBQUs7SUFETCxDQURGO0lBR0FDLEdBQUEsRUFDRTtNQUFBRixNQUFBLEVBQVEsS0FBUjtNQUNBQyxHQUFBLEVBQUs7SUFETCxDQUpGO0lBTUFFLEtBQUEsRUFDRTtNQUFBSCxNQUFBLEVBQVEsTUFBUjtNQUNBQyxHQUFBLEVBQUs7SUFETDtFQVBGLENBREssQ0FBQTtFQVlQLE9BQU9KLElBQUE7QUFkaUQsQ0FBZixDQUEzQyxDQUFBIiwiZmlsZSI6InJlc291cmNlcy9TaG9wLmpzIiwic291cmNlc0NvbnRlbnQiOlsiYW5ndWxhci5tb2R1bGUoICdtYWluQXBwJykuZmFjdG9yeSAnU2hvcCcsIFsgJyRyZXNvdXJjZScsICggJHJlc291cmNlICkgLT5cblxuICBTaG9wID0gJHJlc291cmNlKCAnL2FwaS9zaG9wJywge2lkOiAnQGlkJ30sXG4gICAgcmVkZWVtOlxuICAgICAgbWV0aG9kOiAnUE9TVCdcbiAgICAgIHVybDogJy9hcGkvc2hvcC92b3VjaGVyL3JlZGVlbSdcbiAgICBwYXk6XG4gICAgICBtZXRob2Q6ICdQVVQnXG4gICAgICB1cmw6ICcvYXBpL3Nob3AvcGF5J1xuICAgIHF1b3RlOlxuICAgICAgbWV0aG9kOiAnUE9TVCdcbiAgICAgIHVybDogJy9hcGkvc2hvcC9xdW90ZSdcbiAgKVxuXG4gIHJldHVybiBTaG9wXG5dXG4iXX0=
